<template>
  <div class="dod-container">
    <dod-view-title
      :title="selectedEmployeeStatus ? selectedEmployeeStatus.name : ''"
    />
    <dod-search-input
      :withFilters="true"
      @search="handleSearch"
      @onFilter="handleFilters"
      :filter-settings="['SETTLEMENT_STATUS', 'DEPARTMENT', 'SCOPE_OF_CARE']"
    />
    <pagination-arrows
      v-if="employees.meta && employees.meta.total > 0"
      :onPage="employees.meta.per_page"
      :pageNumber="employees.meta.current_page"
      :total="employees.meta.total"
      @nextPage="handleNextPage"
      @previousPage="handlePreviousPage"
    />
    <div
      class="list"
      v-if="employees && employees.data && employees.data.length > 0"
    >
      <employee-card
        :employee="employee"
        :settlement="settlementByEmployee[employee.id]"
        v-for="employee in employees.data"
        :key="employee.id"
      />
    </div>
    <dod-empty-list v-else />
  </div>
</template>

<script>
import EmployeeCard from "../../components/dod/EmployeeCard.vue";
import DodSearchInput from "../../components/dod/DodSearchInput.vue";
import DodViewTitle from "../../components/dod/DodViewTitle.vue";
import DodEmptyList from "../../components/dod/DodEmptyList.vue";
import PaginationArrows from "../../components/PaginationArrows.vue";
export default {
  components: {
    EmployeeCard,
    DodViewTitle,
    DodSearchInput,
    DodEmptyList,
    PaginationArrows,
  },
  name: "DODEmployees",
  data() {
    return {
      searchValue: "",
      filters: {},
      page: 1,
      limit: 20,
      settlementByEmployee: {},
    };
  },

  async mounted() {
    await this.fetchEmployees(this.urlStatusId, this.searchValue, this.filters);
  },

  computed: {
    employees() {
      return this.$store.getters.getDodEmployees;
    },
    urlStatusId() {
      return this.$route.query.status;
    },
    selectedEmployeeStatus() {
      return this.$store.getters.getSelectedEmployeeStatus;
    },
  },

  watch: {
    async urlStatusId() {
      this.page = 1;
      await this.fetchEmployees(
        this.urlStatusId,
        this.searchValue,
        this.filters
      );
    },
  },

  methods: {
    async handleNextPage() {
      this.page++;
      await this.fetchEmployees(
        this.urlStatusId,
        this.searchValue,
        this.filters
      );
    },
    async handlePreviousPage() {
      this.page--;
      await this.fetchEmployees(
        this.urlStatusId,
        this.searchValue,
        this.filters
      );
    },

    async handleSearch(searchValue) {
      this.searchValue = searchValue;
      await this.fetchEmployees(
        this.urlStatusId,
        this.searchValue,
        this.filters
      );
    },

    async handleFilters(filters) {
      this.filters = {};
      if (filters) {
        filters.forEach((filter) => (this.filters[filter.key] = filter.value));
      }

      await this.fetchEmployees(
        this.urlStatusId,
        this.searchValue,
        this.filters
      );
    },

    async fetchEmployees(statusId, search, filters) {
      await this.$store.dispatch("getDodEmployees", {
        statusId,
        search,
        filters,
        limit: this.limit,
        page: this.page,
        sortBySettlement: true,
      });
      await this.fetchSettlementStatuses();
    },

    async fetchSettlementStatuses() {
      const ids = (this.employees && this.employees.data ? this.employees.data : []).map((e) => e.id);
      if (ids.length === 0) {
        this.settlementByEmployee = {};
        return;
      }
      try {
        const statuses = await this.$store.dispatch("getSettlementStatusesByEmployees", { employeeIds: ids });
        const map = {};
        (statuses || []).forEach((s) => {
          map[s.employeeId] = s;
        });
        this.settlementByEmployee = map;
      } catch (e) {
        this.settlementByEmployee = {};
      }
    },
  },
};
</script>

<style scoped>
.list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0;
}
</style>
